import React from 'react';
import Modal from '../../Components/Modal';
import Grid from '../../Components/Formatting/Grid';
import TimeAgo from '../../Components/Formatting/TimeAgo';
import { plural } from '../../Services/helpers';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import NoValue from '../../Components/EmptyStates/NoValue';

const LeadDetails = ({lead, onClose, doPurchase, isPurchasing}) => {
    return <Modal title="Lead Details" isOpen={!!lead} setIsOpen={onClose} dismissible>

        {lead && <Inner {...{lead, onClose, doPurchase, isPurchasing}} />}

    </Modal>
}

const Inner = ({lead, onClose, doPurchase, isPurchasing}) => {

    return <>
        <Grid items={[
            [
                <strong>Name</strong>,
                lead.name,
            ],
            [
                <strong>Status</strong>,
                lead.status,
                lead.status,
            ],
            [
                <strong>Postcode</strong>,
                lead.postcode,
                lead.postcode,
            ],
            [
                <strong>Distance</strong>,
                `${lead.distance.miles} miles`,
                lead?.distance?.miles,
            ],
            [
                <strong>Building</strong>,
                <>
                    {lead.buildingType}
                    <span className="ml-3 text-muted">
                        {plural(lead.bedrooms, null, '(1 bedroom)', `(${lead.bedrooms} bedrooms)`)}
                    </span>
                </>,
                lead.buildingType,
            ],
            [
                <strong>Frequency</strong>,
                lead.frequency,
                lead.frequency,
            ],
            [
                <strong>Email</strong>,
                lead.email ? lead.email : <NoValue />,
            ],
            [
                <strong>Phone</strong>,
                lead.phoneNumber ? lead.phoneNumber : <NoValue />,
            ],
            [
                <strong>Submitted</strong>,
                <TimeAgo dateTime={lead.quoteSubmittedAt} />,
                lead.quoteSubmittedAt,
            ],
            [
                <strong>Credits</strong>,
                <>
                    {lead.originalCredits && <span className="line-through text-muted mr-3">
                        {plural(lead.originalCredits, null, '1 credit', `${lead.originalCredits} credits`)}
                    </span>}
                    {plural(lead.credits, null, '1 credit', `${lead.credits} credits`)}
                </>,
            ],
        ]} />

        <ButtonRow>
            <Button theme="secondary" label="Close" onClick={() => onClose()} disabled={isPurchasing} />
            <Button theme="primary" label="Purchase" onClick={() => doPurchase(lead)} loading={isPurchasing} />
        </ButtonRow>
    </>
}

export default LeadDetails;
